import { createType } from 'framework/utils/createType';

export const WorkflowFilterTabTypes = createType('all', 'active', 'warning', 'error');
export type WorkflowFilterTabType = typeof WorkflowFilterTabTypes[number];
